// Empty module to replace Node.js built-ins in browser builds
module.exports = {};
